import type { Location } from '@faceup/router'
import { type Language, languageEnumToBasename } from '@faceup/utils'

export const getLanguageRedirect = (
  { pathname, search }: Pick<Location, 'pathname' | 'search'>,
  language: Language
) => {
  const basename = languageEnumToBasename(language)
  const [, languageSegment, ...rest] = pathname.split('/')
  if (languageSegment === basename) {
    return null
  }
  return `${['', basename, ...rest].join('/')}${search}`
}
